// extracted by mini-css-extract-plugin
export default {"container":"Message_container__XH9Io","notFoundHeader":"Message_notFoundHeader__0SPCZ","icon":"Message_icon__4d0Xq","message":"Message_message__PFA7G"};